// client.js
import { createClient } from '@sanity/client'

export default createClient({
  projectId: '26sxkmoh',
  dataset: 'production', // Temporarily back to production until .env.local is set up
  apiVersion: '2021-08-31',
  useCdn: process.env.NODE_ENV === 'production'
})
